export default "__VITE_ASSET__BBWe_JW4__"